import { Injectable } from '@angular/core';
import { HttpClientService } from '@core/services/http-client/http-client.service';
import { API_URL_CONSTANT } from '@sharedModule/constants/api-url.constant';
import { Country } from '@sharedModule/models/country.model';
import { DestinationCountry } from '@sharedModule/models/destination-country.model';
import { ResponseIdentity } from '@sharedModule/models/server-response-identity.model';
import { SourceCountry } from '@sharedModule/models/source-country.model';
import { GcsImageResponse } from '@sharedModule/models/gcs-image.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor(private http: HttpClientService) {}

  getCountryList(): Observable<ResponseIdentity<Country[]>> {
    return this.http.post(API_URL_CONSTANT.common.getCountryList);
  }

  getSourceCountryList(payload?: {
    partner_id?: number;
  }): Observable<ResponseIdentity<SourceCountry>> {
    return this.http.post(
      API_URL_CONSTANT.common.getSourceCountryList,
      payload
    );
  }

  getDestinationCountryList(payload: {
    partner_id?: number;
    src_country: string;
  }): Observable<ResponseIdentity<DestinationCountry>> {
    return this.http.post(
      API_URL_CONSTANT.common.getDestinationCountryList,
      payload
    );
  }

  /**
   * Exchanges a stored GCS link for something the browser can actually show.
   *
   * The response is typed loosely because the endpoint may hand back a signed
   * URL, a data URL or bare base64; normalising that is the caller's job.
   */
  getGcsImage(payload: {
    gcs_image_link: string;
    partner_id?: number;
  }): Observable<ResponseIdentity<GcsImageResponse>> {
    return this.http.post(API_URL_CONSTANT.common.getGcsImage, payload);
  }
}
